import { Grid } from '@mui/material';
import { t } from 'i18next';
import { useFieldArray, useFormContext } from 'react-hook-form';
import ControlledTextField from 'src/shared/components/form/controlledTextField';

export const OrganizationTitleConfigItems = () => {
  const { control } = useFormContext();
  const { fields } = useFieldArray({
    control,
    name: 'items',
  });

  return (
    <>
      {fields.map((item, index) => {
        return (
          <Grid
            container
            spacing={2}
            sx={{
              maxWidth: '40rem',
              mb: 2,
              '& .Mui-disabled': {
                WebkitTextFillColor: (thm) => `${thm.palette.text.primary} !important`,
              },
            }}
            key={item.id}
          >
            <Grid item xs='auto'>
              <ControlledTextField name={`items.${index}.count`} label={t('common:organization.titleConfigModal.count')} sx={{ maxWidth: '6rem' }} />
            </Grid>
            <Grid item>
              <ControlledTextField name={`items.${index}.title`} label={t('common:organization.titleConfigModal.title')} disabled />
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};
